import React from "react";
import { Link } from "react-router-dom";
import "./Hero.scss";
import { candidatesPortalLink } from "utils/Shared";
import playicon from "./../../../assets/images/ic_play.png";
import heroVid from "../../../assets/videos/hrcom-vid.mp4";
import heroVidAr from "../../../assets/videos/hrcom-vid-ar.mp4";
import poster from "../../../assets/images/poster.png";
import { injectIntl } from "react-intl";
import { useSelector } from "react-redux";
const Hero = (props) => {
  const lang = useSelector((state) => state.locale.lang);
  const { messages } = props.intl;
  const playVideo = () => {
    document.getElementById("demo").play();
    document.getElementById("demo").setAttribute("controls", "controls");
  };
  return (
    <>
      {lang === "en" && (
        <div className="hero-section overflow-hidden">
          <div className="container h-100">
            <div className="row align-items-center justify-content-between h-100 mb-2">
              <div
                className="col-xl-6 hero-content mb-5"
                data-aos="fade-up"
                data-aos-duration="3000"
              >
                <h1 className="extra-heading bold_font mb-4">
                  {props.content.title_en}
                </h1>
                <p className="text-content medium_font my-4">
                  {props.content.description_en}
                </p>
                <Link to="/request-demo" className="btn">
                  <button className="btn-primary mt-4 px-5 py-3 medium_font text-uppercase">
                    {messages.buttons.reqestDemo}
                  </button>
                </Link>
              </div>

              <div className=" hero-video mb-5 col-xl-6 text-center ">
                <video id="demo" className=" brd-primary" poster={poster}>
                  <source src={heroVid} type="video/mp4" />
                </video>
                <div
                  className="text-center row justify-content-center text-white start_video"
                  onClick={playVideo}
                >
                  <img src={playicon} />
                  <p className="mt-1 mx-2  text-white medium_font text-uppercase">
                    See how it works...
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {lang === "ar" && (
        <div className="hero-section hero-section-ar ">
          <div className="container h-100">
            <div className="row align-items-center justify-content-between h-100">
              <div
                className="col-xl-6 hero-content mb-5"
                data-aos="fade-up"
                data-aos-duration="3000"
              >
                <h1 className="extra-heading bold_font mb-4">
                  {props.content.title_ar}
                </h1>
                <p className="text-content medium_font my-npm 4">
                  {props.content.description_ar}
                </p>
                <Link to="/request-demo" className="btn">
                  <button className="btn-primary mt-4 px-5 py-3 medium_font ">
                    {messages.buttons.reqestDemo}
                  </button>
                </Link>
              </div>

              <div className="hero-video mb-5 col-xl-6 text-center">
                <video id="demo" className=" brd-primary" poster={poster}>
                  <source src={heroVidAr} type="video/mp4" />
                </video>
                <div
                  className="text-center row justify-content-center text-white start_video"
                  onClick={playVideo}
                >
                  <img src={playicon} />
                  <p className="mt-1 mx-2   text-white medium_font">
                    أعرف أكثر
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default injectIntl(Hero);
